"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardMenuItemFragment = void 0;
const client_1 = require("@apollo/client");
const menuPlannerRecipe_1 = require("./menuPlannerRecipe");
exports.standardMenuItemFragment = client_1.gql `
  fragment StandardMenuItem on MenuItem {
    __typename
    id
    date
    recipe {
      ...MenuPlannerRecipe
    }
    scale
    menuSectionId
  }
  ${menuPlannerRecipe_1.menuPlannerRecipeFragment}
`;
//# sourceMappingURL=menuItem.js.map